/** Sertifika jpg/png’yi base64’e kırpar; büyük görselleri ana iş parçacığını kilitilemez. */
const MAX_FILE_BEFORE_REJECT = 12 * 1024 * 1024; // 12 MB ham dosya
const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.82;

export function fileTooLargeForCertificate(file: File): boolean {
  return file.size > MAX_FILE_BEFORE_REJECT;
}

export function compressImageToDataUrl(
  file: File,
  maxDim = MAX_DIMENSION,
  quality = JPEG_QUALITY
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        if (width > height) {
          height = Math.round((height * maxDim) / width);
          width = maxDim;
        } else {
          width = Math.round((width * maxDim) / height);
          height = maxDim;
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas desteklenmiyor.'));
        return;
      }
      ctx.drawImage(img, 0, 0, width, height);
      try {
        resolve(canvas.toDataURL('image/jpeg', quality));
      } catch (e) {
        reject(e);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Görsel yüklenemedi.'));
    };
    img.src = url;
  });
}

export function normalizeCertificateImagePayload(image?: unknown): string | undefined {
  if (typeof image !== 'string') return undefined;
  if (!image.trim()) return undefined;
  const marker = 'base64,';
  const markerIndex = image.indexOf(marker);
  return markerIndex >= 0 ? image.slice(markerIndex + marker.length) : image;
}

export function certificateImageToDataUrlSrc(image?: unknown): string | undefined {
  if (typeof image !== 'string') return undefined;
  if (!image.trim()) return undefined;
  if (image.startsWith('data:image/')) return image;
  return `data:image/jpeg;base64,${image}`;
}
